import type { CollectionEntry } from "astro:content";

export const getModuleAndLessonIndexFromSlug = (slug: string) => {
  const [_course, module, lesson] = slug.split("/");
  return {
    module: Number(module.split("-")[0]),
    lesson: Number(lesson.split("-")[0]),
  };
};

export const canViewLesson = (
  lesson: Pick<CollectionEntry<"course">, "data">,
  permissions?: { canPreviewLessons: boolean },
) => {
  if (permissions?.canPreviewLessons) {
    return true;
  }

  if (lesson.data.underDevelopment) {
    return false;
  }

  return true;
};
